import config from '@config/index';

/**
 * Azure‑blob URL with SAS‑token.
 * Keeps this logic in a single place.
 */
export const blobHref = (containerId: string, blobName: string, token: string) =>
  `${config.AZURE_STORAGE_BASE_URL}/${containerId}/${encodeURIComponent(blobName)}?${token}`;

/**
 * Backend proxy that forces the browser either to *download*
 * or to *inline‑view* a file.
 * `inline = true`  →  opens in new tab
 * `inline = false` →  triggers download
 */
export const proxyUrl = (rawHref: string, filename: string, mimetype: string, inline = false) => {
  return `${config.BACKEND_URI}/blobs/proxy/${encodeURIComponent(filename)}?url=${encodeURIComponent(
    rawHref
  )}&mimetype=${encodeURIComponent(mimetype)}&inline=${inline ? 'true' : ''}`;
};
